import { createBrowserRouter } from "react-router-dom";
import { RootLayoutClient } from "@/shared";
import routes from "~react-pages";

// Wrap all routes with RootLayoutClient
const routesWithLayout = [
	{
		path: "/",
		element: <RootLayoutClient />,
		children: routes,
	},
];

export const router = createBrowserRouter(routesWithLayout);
